import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { Profile } from './Profile/'
import { SettingsPage, ContentCentered } from '@sales-center/components'
import { SettingsCard } from './SettingsCard.styled'
import { styles } from './useStyles'
import { useDialogState } from '@user/utils/useDialogState'
import { NotificationSettingsFormWrapper } from './Notification/forms/NotificationSettingsFormWrapper'
import { paperClasses } from '@mui/material/Paper'

export function AccountSettings() {
  const [openPanel, onOpenProfile, onCloseProfile] = useDialogState()
  const [openNotificationSetting, onOpenNotification, onCloseNotification] =
    useDialogState()

  return (
    <SettingsPage title="Account Settings" padding="40px">
      <ContentCentered>
        <Box maxWidth={1078} flexGrow={1}>
          <SettingsCard
            elevation={2}
            sx={{ [`&.${paperClasses.root}`]: { ...styles.longCard } }}
          >
            <Box ml={4}>
              <Typography variant="h6">Profile</Typography>
            </Box>

            <Button
              color="primary"
              variant="contained"
              onClick={onOpenProfile}
              sx={styles.button}
            >
              View
            </Button>
          </SettingsCard>
          <SettingsCard elevation={2} sx={styles.longCard}>
            <Box ml={4}>
              <Typography variant="h6">Notification Preferences</Typography>
            </Box>

            <Button
              color="primary"
              variant="contained"
              onClick={onOpenNotification}
              sx={styles.button}
            >
              Manage
            </Button>
          </SettingsCard>

          {openPanel && <Profile onClose={onCloseProfile} open={openPanel} />}
          {openNotificationSetting && (
            <NotificationSettingsFormWrapper
              onClose={onCloseNotification}
              open={openNotificationSetting}
            />
          )}
        </Box>
      </ContentCentered>
    </SettingsPage>
  )
}
